import { Button } from 'antd'

import { auditAuctionApplyApi } from '@eastcoal/api/trade/applyOperation/auditAuctionApply'

import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { pick } from '@eastcoal/common/utils/object'

import { CrudPopform } from '@eastcoal/formily/components/CrudPopform'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { RadioGroup } from '@eastcoal/formily/components/Radio'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { TextArea } from '@eastcoal/formily/components/TextArea'

import { ApplyStatus } from '@eastcoal/shared/enums/ApplyStatus'

import { ApplyAuditButtonProps } from './interface'

const schema: SchemaItem[] = [
  {
    name: 'id',
    type: 'string',
    'x-display': 'hidden'
  },
  {
    name: 'pass',
    title: '是否通过',
    type: 'boolean',
    enum: [
      {
        label: '通过',
        value: true
      },
      {
        label: '不通过',
        value: false
      }
    ],
    'x-decorator': FormItem,
    'x-component': RadioGroup
  },
  {
    name: 'reason',
    title: '原因',
    type: 'string',
    required: '{{ !$values.pass }}',
    'x-decorator': FormItem,
    'x-component': TextArea
  }
]

export const ApplyAuditButton = ({ record }: ApplyAuditButtonProps) => {
  const { reload } = useRemoteTableStore(state => pick(state, ['reload']))

  return record.status === ApplyStatus.WAIT_PLATFORM_AUDIT ? (
    <CrudPopform
      api={auditAuctionApplyApi}
      name='applyAuditForm'
      schema={schema}
      title='邀约审核'
      type='success'
      initialValues={{
        id: record.id,
        pass: true
      }}
      onSuccess={() => reload()}
    >
      <Button danger type='link'>
        审核
      </Button>
    </CrudPopform>
  ) : null
}
